import worker from '../../img/employees/worker.svg';
import foreman from '../../img/employees/foreman.svg';
import HRImg from '../../img/employees/get-hired.svg';
import trader from '../../img/employees/businessman.svg';
import engineer from '../../img/employees/engineer.svg';

import airplane1 from '../../img/aircraft/airplane1.svg';
import aeroplane3 from '../../img/aircraft/aeroplane3.svg';
import aeroplane2 from '../../img/aircraft/aeroplane2.svg';

import japan from '../../img/flags/japan.svg';
import canada from '../../img/flags/canada.svg';
import brazil from '../../img/flags/brazil.svg';
import germany from '../../img/flags/germany.svg';
import china from '../../img/flags/china.svg';
import australia from '../../img/flags/australia.svg';
import russia from '../../img/flags/russia.svg';
import cameroon from '../../img/flags/cameroon.svg';
import chile from '../../img/flags/chile.svg';
import colombia from '../../img/flags/colombia.svg';
import finland from '../../img/flags/finland.svg';
import france from '../../img/flags/france.svg';
import italy from '../../img/flags/italy.svg';
import jamaica from '../../img/flags/jamaica.svg';
import korea from '../../img/flags/korea.svg';
import poland from '../../img/flags/poland.svg';

import warehouse from '../../img/parts/warehouse.svg';
import ship from '../../img/parts/ship.svg';
import movingTruck from '../../img/parts/truck.svg';
import truckUnloading from '../../img/parts/truck2.svg';

export const images = {
  'Workers': worker,
  'Foremen': foreman,
  'Human Resources': HRImg,
  'Traders': trader,
  'Engineers': engineer,

  'Boeing 737-700': airplane1,
  'Helicopter': aeroplane3,
  'Airbus A320': aeroplane2,
  'Baloon': airplane1,
  'F-16': aeroplane2,
  'Dreamliner': aeroplane3,

  'Japan': japan,
  'Canada': canada,
  'Brazil': brazil,
  'Germany': germany,
  'China': china,
  'Australia': australia,
  'Russia': russia,
  'Cameroon': cameroon,
  'Chile': chile,
  'Colombia': colombia,
  'Finland': finland,
  'France': france,
  'Italy': italy,
  'Jamaica': jamaica,
  'Korea': korea,
  'Poland': poland,

  warehouse,
  ship,
  movingTruck,
  truckUnloading,
};
